module.exports = __webpack_public_path__ + "img/icon2-1.9fdf1f4a.svg";